export const ProductActionTypes = {
    API_RESPONSE_SUCCESS: '@@products/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@products/API_RESPONSE_ERROR',
    READ_ALL_PRODUCTS_REQUEST: '@@products/READ_ALL_PRODUCTS_REQUEST',
    CREATE_PRODUCT_REQUEST: '@@products/CREATE_PRODUCT_REQUEST',
    UPDATE_PRODUCT_REQUEST: '@@products/UPDATE_PRODUCT_REQUEST',
    DELETE_PRODUCT_REQUEST: '@@products/DELETE_PRODUCT_REQUEST',
};
